import http from '@/utils/http';

import { listSearch, listUpdate } from '@/models/maintenanceManagement/businessLineMaintenance';

/**
 * @Author: YuKi
 * @description: 分页获取业务�?
 * @param {listSearch} params 接口传参
 * @return {*}
 */
export const getBusinessLinePage = (params: listSearch): Promise<any> =>
  http.get({ url: '/ams/businessLine/getBusinessLinePage', params });

/**
 * @Author: YuKi
 * @description:编辑业务�?
 * @param {listUpdate} data  接口传参
 * @return {*}
 */
export const editBusinessLine = (data: listUpdate): Promise<any> =>
  http.post({ url: '/ams/businessLine/editBusinessLine', data });

/**
 * @Author: YuKi
 * @description:删除业务�?
 * @param {string} id  接口传参
 * @return {*}
 */
export const delBusinessLine = (id: string): Promise<string> =>
  http.delete({ url: `/ams/businessLine/delBusinessLine?id=${id}` });
